export class ContactInfoTypeModel {

    public preferredCommunicationCode = '002'; // email, mobileNumber, fax
    public email: string;
    public mobileNumber: string;
    public fax: string;

}
